import { createContext, useContext, useEffect, useRef, useState } from "react";
import { getMsGraphUserPhotoUrl } from "../../../services/graph";
import { useSymphonyApiService } from "../../../hooks/useSymphonyApi";
import { useAccess } from "./AccessContext";
import { useAuthentication } from "../../../contexts/AuthContext";
import { debugLog } from "../../../configs/loggingConfig";


const ProfilePictureContext = createContext();

function ProfilePictureProvider({ children }) {

    const { graphAccessToken } = useAuthentication();
    const apiServiceClient = useSymphonyApiService("framework", "v3");
    const { chatMembers } = useAccess()

    const [userProfileImages, setUserProfileImages] = useState({});

    useEffect(() => {
        populateProfileImages();
    }, [chatMembers])

    // Revoke all blobs only on unmount
    useEffect(() => {
        return () => {
            Object.values(userProfileImages).forEach(url => {
                if (url && typeof url === 'string' && url.startsWith('blob:')) {
                    window.URL.revokeObjectURL(url);
                }
            });
        };
    }, [])

    const populateProfileImages = async () => {
        const newImages = { ...userProfileImages }
        for (const member of chatMembers) {
            if (!newImages[member.userProfile.userProfileId]) {
                const img = await getImage(member.userProfile);
                newImages[member.userProfile.userProfileId] = img;
            }
        }
        setUserProfileImages(newImages);
    }

    const getImage = async (userProfile) => {

        return await getMsGraphUserPhotoUrl(graphAccessToken, userProfile.identifier)
            .then((photo) => {
                const url = window.URL || window.webkitURL;
                const newPhoto = url.createObjectURL(photo);
                return newPhoto;
            })
            .catch((error) => {
                debugLog.warn("The user does not have a profile picture. Defaulting to the user's initials.\n", error);
                // call the name abbreviation endpoint - Using pfpUPN.Split for now,but we should probably add last name to the userProfile context and obfuscate this Avatar link creation behind the API.
                const newPhoto = `https://ui-avatars.com/api/?name=${userProfile.givenName} ${userProfile.familyName}`;
                return newPhoto;
            });
    }


    return (
        <ProfilePictureContext.Provider
            value={{
                // Data
                userProfileImages

                // Functions

            }}
        >
            {children}
        </ProfilePictureContext.Provider>
    );
}

// Hook to use the MessagesContext in a component
function useProfilePictures() {
    const context = useContext(ProfilePictureContext);
    if (context === undefined) {
        throw new Error(
            "userProfilePictures must be used within a ProfilePictureProvider"
        );
    }
    return context;
}

export { ProfilePictureProvider, useProfilePictures };
